import {
  DialogDescription,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogClose,
  DialogTitle,
  Button,
  Dialog,
  toast,
} from '@ui/components';
import { useOnboardingImportedVehicles } from '@pages/onboarding/hooks';
import { EmployeeDto } from '@interfaces/models';
import { useTranslation } from 'react-i18next';

export const RemoveVehicleDialog = ({
  assignedEmployees,
  vehicleId,
  isOpen,
  onClose,
}: {
  onClose: ({ hasBeenModified }?: { hasBeenModified?: boolean }) => void;
  assignedEmployees: EmployeeDto[];
  vehicleId: string;
  isOpen: boolean;
}) => {
  const { t } = useTranslation();

  const { removeVehicle, isRemoveVehiclePending } = useOnboardingImportedVehicles({
    onRemoveVehicleSuccess: () => {
      onClose({ hasBeenModified: true });
      toast.success(t('ONBOARDING.IMPORT_VEHICLES.VEHICLE_REMOVED_SUCCESSFULLY'));
    },
    onRemoveVehicleError: () => {
      toast.error(t(`API_ERRORS.DEFAULT`));
    },
  });

  const MAX_ASSIGNED_EMPLOYEES = 3;

  const description =
    assignedEmployees.length > MAX_ASSIGNED_EMPLOYEES
      ? t('ONBOARDING.IMPORT_VEHICLES.REMOVE_VEHICLE_DIALOG_DESCRIPTION_MORE_THAN', {
          assignedEmployees: assignedEmployees
            .slice(0, MAX_ASSIGNED_EMPLOYEES)
            .map((employee) => `${employee.firstName} ${employee.lastName}`)
            .join(', '),
          assignedEmployeesCount: assignedEmployees.length - MAX_ASSIGNED_EMPLOYEES,
        })
      : t('ONBOARDING.IMPORT_VEHICLES.REMOVE_VEHICLE_DIALOG_DESCRIPTION', {
          assignedEmployees: assignedEmployees
            .map((employee) => `${employee.firstName} ${employee.lastName}`)
            .join(', '),
        });

  return (
    <Dialog onOpenChange={() => onClose()} open={isOpen}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('ONBOARDING.IMPORT_VEHICLES.REMOVE_VEHICLE_DIALOG_TITLE')}</DialogTitle>
        </DialogHeader>
        <DialogDescription>{description}</DialogDescription>
        <DialogFooter>
          <DialogClose asChild>
            <Button disabled={isRemoveVehiclePending} variant="tertiary" size="large" wide>
              {t('ONBOARDING.IMPORT_VEHICLES.REMOVE_VEHICLE_DIALOG_CANCEL')}
            </Button>
          </DialogClose>
          <Button
            onClick={() => removeVehicle(vehicleId)}
            isLoading={isRemoveVehiclePending}
            disabled={isRemoveVehiclePending}
            size="large"
            wide
          >
            {t('ONBOARDING.IMPORT_VEHICLES.REMOVE_VEHICLE_DIALOG_DELETE')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
